import { render } from "./BirthDayPage.vue?vue&type=template&id=18d470ce&scoped=true"
import script from "./BirthDayPage.vue?vue&type=script&lang=js"
export * from "./BirthDayPage.vue?vue&type=script&lang=js"

import "./BirthDayPage.vue?vue&type=style&index=0&id=18d470ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d470ce"]])

export default __exports__